interface Props {
  colour: string
}
const Color = ({ colour }: Props) => {
  return (
    <>
      <div className="w-4 h-4 rounded-full circle border" />
      <style jsx>
        {`
          .circle {
            border: none;
            background-color: ${colour};
          }
        `}
      </style>
    </>
  )
}
export default Color
